<template>
  <div>
    <button class="btn btn-lg btn-primary button" @click="onUploadClick">
      <strong>Upload New Image</strong>
    </button>

    <upload-gallery-image-modal :shown="modalShown" @close-modal="onCloseModal"></upload-gallery-image-modal>
  </div>
</template>

<script>
import UploadGalleryImageModal from './UploadGalleryImageModal';
import {showProfileLockedWarning} from '../../../utility/showProfileLockedWarning';

export default {
  name: 'upload-gallery-image-button',
  components: {UploadGalleryImageModal},
  data() {
    return {
      modalShown: false,
    };
  },
  props: {
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    onUploadClick() {
      showProfileLockedWarning.warning(this.profileLocked).then(() => {
        this.modalShown = true;
      });
    },
    onCloseModal() {
      this.modalShown = false;
    },
  },
};
</script>
